import { RxConversationAPI } from '@driftt/dapper'

export const api = {
  updateInbox(id, properties) {
    return RxConversationAPI
    .patch(`/inboxes/${id}`, properties)
    .checkStatus()
    .retryWithBackoff()
  }
}
